<div class="flex flex-col gap-4 p-4">
  <p-message
    *ngIf="!canAdd"
    severity="warn"
    text="Veuillez d'abord sélectionner le poste technique (et donc l'usine) de la règle à l'étape Localisation avant d'ajouter une formule de gain."
  ></p-message>
  <p-message *ngIf="loadError" severity="error" [text]="loadError"></p-message>

  <div class="flex items-center gap-3">
    <p-treeselect
      class="w-full md:w-96"
      [options]="templateNodes"
      [ngModel]="pickerValue"
      [filter]="true"
      [disabled]="!canAdd || loading || !!loadError"
      placeholder="Ajouter une formule de gain..."
      emptyMessage="Aucun modèle de formule disponible"
      appendTo="body"
      (onNodeSelect)="onTemplateSelected($event)"
    ></p-treeselect>
    <p-progressSpinner
      *ngIf="loading"
      [style]="{ width: '24px', height: '24px' }"
    ></p-progressSpinner>
  </div>

  <small *ngIf="drafts.length > 0" class="text-gray-500">
    L'usine de la règle ne peut pas être modifiée tant que des formules de gain
    sont définies.
  </small>

  <p *ngIf="!loading && drafts.length === 0" class="text-gray-500">
    Aucune formule de gain pour cette règle.
  </p>

  <div
    *ngFor="let draft of drafts"
    class="border border-gray-200 rounded-xl p-4 flex flex-col gap-3"
  >
    <div class="flex items-start justify-between gap-3">
      <div class="flex flex-col min-w-0">
        <span class="font-semibold truncate">{{ draft.templateName }}</span>
        <span *ngIf="draft.typePath" class="text-xs text-gray-500 truncate">{{
          draft.typePath
        }}</span>
      </div>
      <div class="flex items-center gap-2 flex-wrap justify-end">
        <p-tag
          *ngFor="let marker of markers(draft)"
          [value]="marker.label"
          [severity]="marker.severity"
          [pTooltip]="marker.tooltip || ''"
        ></p-tag>
        <button
          pButton
          type="button"
          icon="pi pi-trash"
          class="p-button-text p-button-danger p-button-sm"
          pTooltip="Retirer cette formule"
          (click)="removeDraft(draft)"
        ></button>
      </div>
    </div>

    <code class="text-sm bg-gray-50 rounded p-2 break-words">{{
      draft.equation
    }}</code>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div
        *ngFor="let parameter of draft.parameters"
        class="flex flex-col gap-1"
      >
        <label class="font-medium"
          >{{ parameter.name }} <span class="text-red-500">*</span></label
        >
        <ng-container *ngIf="parameter.type === 'List'">
          <p-select
            [options]="parameter.options"
            optionLabel="label"
            optionValue="value"
            [(ngModel)]="parameter.selectedValueUid"
            (onChange)="onValueChange()"
            placeholder="Sélectionnez une valeur"
            appendTo="body"
            [panelStyle]="{ width: '100%' }"
            class="w-full"
          ></p-select>
          <small
            *ngIf="parameter.options.length === 0"
            class="text-orange-600 text-xs"
            >Aucune valeur disponible pour cette usine.</small
          >
          <small
            *ngIf="parameter.options.length > 0 && !parameter.selectedValueUid"
            class="text-red-500 text-xs"
            >Une valeur est requise.</small
          >
        </ng-container>
        <ng-container *ngIf="parameter.type === 'Decimal'">
          <p-inputnumber
            mode="decimal"
            [minFractionDigits]="0"
            [maxFractionDigits]="6"
            [useGrouping]="false"
            placeholder="Saisissez une valeur"
            [ngModel]="parameter.typedValue"
            (ngModelChange)="parameter.typedValue = $event; onValueChange()"
            class="w-full"
          ></p-inputnumber>
          <small
            *ngIf="parameter.typedValue === null || parameter.typedValue === undefined"
            class="text-red-500 text-xs"
            >Une valeur est requise.</small
          >
        </ng-container>
      </div>
    </div>
  </div>
</div>
